import React from "react";
import { CityDropdownForTrip, CommonDatePicker, CommonInput } from "components";

const LoadFormFields = ({ load, setLoads, fetchConsignorList, fetchCityList, onEwayInputClick, masterData }) => {
  const errors = load.errors || {};

  const update = (field, value) =>{
    console.log(value)
    setLoads((prev) =>
      prev.map((l) =>
        l.id === load.id
          ? { ...l, [field]: value, errors: { ...l.errors, [field]: "" } }
          : l
      )
    );
  }
    

  const handleNumericInput = (field, value) => {
    if (!/^\d*\.?\d*$/.test(value)) return;
    let formattedValue = value;
    if (value.includes(".")) {
      const [integer, decimal] = value.split(".");
      formattedValue = `${integer}.${decimal.substring(0, 2)}`;
    }
    update(field, formattedValue);
  };

  const handleKeyDown = (e, field) => {
    if (field === "quantity") {
      if (["E", "e", "-", "+", "."].includes(e.key)) e.preventDefault();
    } else {
      if (["E", "e", "-", "+"].includes(e.key)) e.preventDefault();
    }
  };

  return (
    <>
      {/* Eway Row */}
      <div className='load-form-row eway-row with-box-bg'>
        <div className="form-field" style={{ flex: '9.5%' }}>
          <div
            onClick={!load.ewayFetchLoading ? onEwayInputClick : undefined}
            style={{ cursor: load.ewayFetchLoading ? "not-allowed" : "pointer", maxWidth: load.ewayBillNumber ? '' : '39%', width: '100%' }}
          >
            <CommonInput
              label="Eway Bill Number"
              placeholder="Eway Bill Number"
              value={load.ewayBillNumber || ""}
              onChange={() => { }}
              onKeyDown={(e) => e.preventDefault()}
              error={errors.ewayBillNumber}
              focus={!!errors.ewayBillNumber}
              readOnly={true}
              style={{ cursor: "pointer", pointerEvents: "none" }}
            />
          </div>
        </div>

        {load.ewayBillNumber && (
          <>
            <div className="form-field">
              <CommonDatePicker
                label="Eway Start Date"
                placeholder="Eway Bill Start Date"
                startDate={load.ewayStartDate || null}
                setStartDate={(val) => update("ewayStartDate", val)}
                id={`eway-start-${load.id}`}
                maxDate={new Date()}
              />
            </div>
            <div className="form-field">
              <CommonDatePicker
                label="Eway End Date"
                id={`eway-end-${load.id}`}
                showTimeSelect={false}
                defaultTimeFix={true}
                minDate={load.ewayStartDate}
                placeholder="Eway Bill Expiry Date"
                startDate={load.ewayExpiryDate || null}
                setStartDate={(val) => update("ewayExpiryDate", val)}
                error={errors.ewayExpiryDate}
                focus={!!errors.ewayExpiryDate}
              />
            </div>
          </>
        )}
      </div>

      {/* Party + Location Row */}
      <div className="load-form-row party-row">
        <div className="form-field">
          <CityDropdownForTrip
            placeholder="Select Party *"
            fetchData={fetchConsignorList}
            pageSize={20}
            onChange={(val) => update("party", val)}
            selectedItem={load.party || null}
            error={!!errors.party}
            errorMessage={errors.party}
          />
        </div>
        <div className="form-field">
          <CityDropdownForTrip
            placeholder="From Location *"
            fetchData={fetchCityList}
            pageSize={20}
            onChange={(val) => update("fromLocation", val)}
            selectedItem={load.fromLocation || null}
            error={!!errors.fromLocation}
            errorMessage={errors.fromLocation}
          />
        </div>
        <div className="form-field">
          <CityDropdownForTrip
            placeholder="To Location *"
            fetchData={fetchCityList}
            pageSize={20}
            onChange={(val) => update("toLocation", val)}
            selectedItem={load.toLocation || null}
            error={!!errors.toLocation}
            errorMessage={errors.toLocation}
          />
        </div>
        <div className="form-field">
          <CommonInput
            placeholder="MLR Number"
            value={load.mlrNumber || ""}
            onChange={({ target: { value } }) => update("mlrNumber", value)}
            maxLength={12}
          />
        </div>
        <div className="form-field">
          <CommonInput
            placeholder="Invoice Number"
            value={load.invoiceNumber || ""}
            onChange={({ target: { value } }) => update("invoiceNumber", value)}
            maxLength={12}
          />
        </div>
      </div>

      {/* Item Details Row */}
      <div className="load-form-row details-row">

        {/* Product Description */}
        <div className="form-field">
          <CommonInput
            type="text"
            placeholder="Description"
            value={load.productDescription || ""}
            maxLength={100}
            onChange={({ target: { value } }) => update("productDescription", value)}
          />
        </div>

        {/* ✅ Weight — inline weight_type select */}
        <div className="form-field">
          <div style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #d1d5db",
            borderRadius: "6px",
            overflow: "hidden",
            background: "#fff",
          }}>
            <input
              type="number"
              placeholder="Weight"
              value={load.weight > 0 ? load.weight : ""}
              maxLength={8}
              onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
              onKeyDown={(e) => handleKeyDown(e, "weight")}
              onChange={({ target: { value } }) => handleNumericInput("weight", value)}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                boxShadow: "none",
                background: "transparent",
                padding: "8px 10px",
                fontSize: "13px",
                color: "#111827",
                minWidth: 0,
              }}
            />
            <select
              value={load.weight_type || 1}
              onChange={({ target: { value } }) => update("weight_type", +value)}
              style={{
                border: "none",
                borderLeft: "1px solid #e5e7eb",
                background: "#f9fafb",
                outline: "none",
                fontSize: "11px",
                color: "#374151",
                padding: "0 20px 0 6px",
                minHeight: "43px",
                minWidth: "52px",
                maxWidth: "64px",
                cursor: "pointer",
                appearance: "none",
                WebkitAppearance: "none",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%236b7280' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 4px center",
              }}
            >
              {masterData?.material_weight_type_list?.map((el, idx) => (
                <option key={idx} value={el?.id}>{el?.name}</option>
              ))}
            </select>
          </div>
        </div>

        {/* ✅ Quantity — inline qty_type select */}
        <div className="form-field">
          <div style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #d1d5db",
            borderRadius: "6px",
            overflow: "hidden",
            background: "#fff",
          }}>
            <input
              type="number"
              placeholder="QTY"
              value={load.quantity > 0 ? load.quantity : ""}
              maxLength={8}
              onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
              onKeyDown={(e) => handleKeyDown(e, "quantity")}
              onChange={({ target: { value } }) => handleNumericInput("quantity", value)}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                boxShadow: "none",
                background: "transparent",
                padding: "8px 10px",
                fontSize: "13px",
                color: "#111827",
                minWidth: 0,
              }}
            />
            <select
              value={load.qty_type || 1}
              onChange={({ target: { value } }) => update("qty_type", +value)}
              style={{
                border: "none",
                borderLeft: "1px solid #e5e7eb",
                background: "#f9fafb",
                outline: "none",
                fontSize: "11px",
                color: "#374151",
                padding: "0 20px 0 6px",
                minHeight: "43px",
                minWidth: "52px",
                maxWidth: "64px",
                cursor: "pointer",
                appearance: "none",
                WebkitAppearance: "none",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%236b7280' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 4px center",
                borderRadius: 0
              }}
            >
              {masterData?.material_qty_type_list?.map((el, idx) => (
                <option key={idx} value={el?.id}>{el?.name}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Sales Value */}
        <div className="form-field">
          <CommonInput
            type="number"
            placeholder="Amount (₹)"
            value={load.salesValue > 0 ? load.salesValue : ""}
            maxLength={10}
            onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
            onKeyDown={(e) => handleKeyDown(e, "salesValue")}
            onChange={({ target: { value } }) => handleNumericInput("salesValue", value)}
          />
        </div>

        {/* KOT */}
        <div className="form-field">
          <CommonInput
            type="number"
            placeholder="KOT"
            value={load.kot > 0 ? load.kot : ""}
            maxLength={8}
            onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
            onKeyDown={(e) => handleKeyDown(e, "kot")}
            onChange={({ target: { value } }) => handleNumericInput("kot", value)}
          />
        </div>

      </div>
    </>
  );
};

export default LoadFormFields;